export const DocumentStatus = {
	NotUpload: 'NotUpload', //尚未上傳
	Checking: 'Checking', //收件確認中
	MissingFile: 'MissingFile', //缺少文件
	Finish: 'Finish', //確認收件
	NotMatch: 'NotMatch', //文件不符
	UnSubmitted: 'UnSubmitted', //尚未提交
}

export const EnrollFlowStep = {
	StudentInfo: '11', //學籍資料
	UploadDocument: '12', //上傳文件
	Payment: '13', //繳費
}

export const StudentDocStatus = {
	NotSubmitted: 'NotSubmitted', //尚未提交
	Reviewing: 'Reviewing', //審核中
	Returned: 'Returned', //退回
	Finish: 'Finish', //收登完成
}
